// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__pZkVI","flexRow":"styles_flexRow__tuEap","cardItem":"styles_cardItem__tXXSG"};